import {createStore} from 'redux';
import reducers from './Reducers';
import {MyWindow} from '../types/MyWindow';
import ReduxState from '../types/ReduxState';

declare const window: MyWindow;

const store = createStore<ReduxState>(reducers, /* preloadedState, */
   window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__());

export default store;
